import { render, staticRenderFns } from "./jaPrivacy.vue?vue&type=template&id=2d1f5f9a&scoped=true&"
import script from "./jaPrivacy.vue?vue&type=script&lang=js&"
export * from "./jaPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./jaPrivacy.vue?vue&type=style&index=0&id=2d1f5f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1f5f9a",
  null
  
)

export default component.exports